module.exports = __webpack_public_path__ + "media/components/Switch/on-e629cc2fbe8261a4cf32d2883b2b8abac0ed3ddfe618931e0f539062e4df6bd1.svg";